import { useEffect } from 'react';
import { useAuthStore } from '@/shared/state/authStore';

export function useBranding() {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;

    (async () => {
      try {
        const { adminFetch } = await import('@/shared/api/adminApi');
        const tenant = await adminFetch<Record<string, unknown>>('/tenant/me');

        const root = document.documentElement;
        if (tenant.primaryColor) root.style.setProperty('--color-accent-primary', tenant.primaryColor as string);
        if (tenant.accentColor) root.style.setProperty('--color-accent-info', tenant.accentColor as string);
      } catch {
        // Branding not available — use defaults
      }
    })();
  }, [isAuthenticated]);
}
